import { render, staticRenderFns } from "./HeaderDropdownNotifications.vue?vue&type=template&id=de0bdc4c&"
import script from "./HeaderDropdownNotifications.vue?vue&type=script&lang=js&"
export * from "./HeaderDropdownNotifications.vue?vue&type=script&lang=js&"
import style0 from "./HeaderDropdownNotifications.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports